import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { get, post, errMsg, dt, label } from "@/lib/api";
import { useAuth } from "@/context/Auth";
import { PageHeader, Card, Btn, Field, Table, useFetch } from "@/components/kit";

export default function Profile() {
  const { user, refresh, setUser } = useAuth();
  const nav = useNavigate();
  const { data } = useFetch(() => get("/auth/sessions"), []);
  const [f, setF] = useState({});
  const change = async () => { try { await post("/auth/change-password", f); toast.success("Password changed"); setF({}); } catch (e) { toast.error(errMsg(e)); } };
  const all = async () => { await post("/auth/logout-all"); setUser(false); nav("/login"); };
  const twofa = async () => { await post("/auth/2fa", { enabled: !user.twofa_enabled }); await refresh(); toast.success("2FA updated"); };
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <PageHeader title="Profile & security" subtitle={`${user.name} · ${label(user.role)} · ${user.email || user.mobile}`} />
      {user.role !== "customer" && (
        <div className="grid gap-6 md:grid-cols-2">
          <Card title="Change password">
            <div className="space-y-3"><Field label="Current password" name="old_password" type="password" form={f} setForm={setF} /><Field label="New password" name="new_password" type="password" form={f} setForm={setF} />
              <Btn data-testid="change-password-btn" onClick={change}>Update</Btn></div>
          </Card>
          <Card title="Two-factor authentication">
            <p className="text-sm text-slate-600">Email OTP on every password login. Recommended for Super Admin.</p>
            <Btn className="mt-3" data-testid="toggle-2fa-btn" variant={user.twofa_enabled ? "outline" : "primary"} onClick={twofa}>{user.twofa_enabled ? "Disable 2FA" : "Enable 2FA"}</Btn>
          </Card>
        </div>
      )}
      <Card title="Login history & devices" action={<Btn variant="danger" className="h-7 px-3 text-xs" data-testid="logout-all-btn" onClick={all}>Logout from all devices</Btn>}>
        <Table testid="sessions-table" rows={data || []} cols={[{ k: "created_at", h: "Login", r: (s) => dt(s.created_at) }, { k: "method", h: "Method" }, { k: "ip", h: "IP" },
          { k: "user_agent", h: "Device", r: (s) => <span className="block max-w-xs truncate text-xs">{s.user_agent}</span> }, { k: "s", h: "Status", r: (s) => (s.current ? "This device" : s.revoked ? "Revoked" : "Active") }]} />
      </Card>
    </div>
  );
}
